import { IxLookupService, IxNgBusyFormService } from 'ix-ng-components';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { IxNgCacheService, IxNgRoutingService } from 'ix-ng-routing';
import { IxNgErrorHandlingService, IxNgFormsStaticUtils } from 'ix-ng-forms';
import { inject, Injectable } from '@angular/core';
import { RowsLookupDTO, RowsLookupFilterDTO } from './rows-lookup.model';

@Injectable()
export class RowsLookupService extends IxLookupService<
  number,
  undefined,
  RowsLookupDTO,
  RowsLookupFilterDTO
> {
  constructor() {
    const ixKeycloakHttp = inject(IxKeycloakHttp);
    const ixNgRoutingService = inject(IxNgRoutingService);
    const ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
    const ixNgHttpService = inject(IxNgHttpService);
    const ixNgBusyFormService = inject(IxNgBusyFormService);
    const ixNgCacheService = inject(IxNgCacheService);

    super(
      ixKeycloakHttp,
      ixNgRoutingService,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
      ixNgCacheService,
      'rowsLookupDTO[]',
      '/lookup/rowsLookup',
    );
    this.predpomnenje = false;
  }

  filterById(row: RowsLookupDTO, idSeznam: number[]): boolean {
    return row.id !== null && row.id !== undefined && idSeznam?.includes(row.id);
  }

  searchFunction(row: RowsLookupDTO, searchValue: string): boolean {
    return (
      // Function defines on which fields you search
      IxNgFormsStaticUtils.searchFunction(searchValue, row.numberOfRows)
    );
  }

  getReadUrl(): string {
    return `readRowsLookup`;
  }

  getFilterType(): RowsLookupFilterDTO {
    return new RowsLookupFilterDTO();
  }

  /**
   * Function for filtering results after reading results of cached lookup.
   * @param row
   * @param filter
   */
  override customFilter(row: RowsLookupDTO, filter: RowsLookupFilterDTO): boolean {
    if (filter.searchValue) {
      if (!row.numberOfRows?.toUpperCase()?.includes(filter.searchValue.toUpperCase()))
        return false;
    }
    if (filter.prikaziAktivne === true) {
      if (row.aktiven !== true) return false;
    }
    return true;
  }
}
